// 按页面划分
export default {
    // 公共页面
    common: {
        detail: '詳細',
        confirm: '確定',
        cancel: 'キャンセル',
        no_data: '利用可能なデータがありません',
        no_data_text: '現在、表示できるデータはありません',
        network_error: 'エラーが発生しました',
        network_error_text: "問題解決のため、修復中です。しばらく経ってから再度お試しください。",
        network_contact: 'お問い合わせ',
        network_for_support: "お問い合わせ",
        refresh: '更新する',
    },
    pullCom: {
        pull: 'スクロールして更新',
        release: '離すと更新',
        refresh: '更新中…',
    },
    index: {
        searchTip: '国/地域を探す',
        exclusiveTit: '専属特典',
        more: 'その他',
        mainlandTit: '中国大陸エリア',
        hkPackageTit: 'Hong Kong (China) packages',
        popularDestTit: 'Popular destinations',
        countryList: {
            cn: 'Mainland China',
            singapore: 'Singapore',
            hk: 'Hong Kong(China)',
            us: 'United States',
            thailand: 'Thailand',
            germany: 'Germany',
            italy: 'Italy',
            more: 'その他'
        },
        regionalPackage: '周遊データ(複数地域含む)',
        recommendPackage: 'おすすめ',
        from: 'から',
        guide: '初心者ガイドライン',
        sepcialArea: 'ご利用エリア',
        lastUpdate: '最終更新',
        successRefresh: '更新完了',
    },
    packages: {
        sub_title: {
            us: 'グアムとサイパンを除く',
            it: 'バチカン市国、サンマリノを含む',
            va: 'イタリア、サンマリノを含む',
            sm: 'イタリア、バチカン市国を含む',
            ma: '西サハラを含む',
            eh: 'モロッコを含む',
            ch: 'リヒテンシュタインを含む',
            li: 'スイスを含むを',
            fr: 'モナコを含む',
            mc: 'フランスを含む',
            fi: 'オーランド諸島を含む',
            ax: 'フィンランドを含む',
            gu: 'サイパンを含む',
            mp: 'グアムを含む'
        },
        unlimited_packages: '無制限のデータプラン',
        normal_packages: 'データパッケージ',
        multi_region_packages: '複数エリア対象パッケージ',
        sale_text: '割引',
        high_speed_text: 'データ',
        high_speed_text_year: '高速通信/月',
        periodUnit: {
            day: '日',
            month: '月',
            hour: '時間',
            year: '年',
        },
        periodUnits: {
            day: '日',
            month: '月',
            hour: '時間',
            year: '年',
        },
        periodUnitSimp: {
            day: '日',
            month: '月',
            hour: '時間',
            year: '年'
        },
        periodUnitsSimp: {
            day: '日',
            month: '月',
            hour: '時間',
            year: '年'
        },
        unlimited_good_name: {
            day: 'Day Pass',
            month: 'Monthly Pass',
            year: 'Yearly Pass'
        },
        day_invalid: '当日失効',
        month_invalid: '当月失効',
        immediate_valid: '即時有効',
        tomorrow_day_valid: '翌日有効',
        tomorrow_month_valid: '翌月有効',
    },
    point: {
        title: 'ポイント',
        point_history: 'ポイント明細',
        my_point: 'ポイント',
        will_expire_on: 'ポイント有効期限',
        total: '合計',
        more: 'その他',
        redeem_for_package: 'データと交換',
        redeem_for_balance: '残高と交換',
        redeem_for_coupon: 'クーポンと交換',
        points: 'ポイント',
        dataPlans: "データと交換",
        Balance: "残高と交換",
        coupon: "クーポンと交換",
        signIn:"チェックイン",
        getPoint:"ポイントを獲得",
        lottery:"ポイントとリワード",
        getPrizes:"賞品を獲得",
        membership_point_rules: '会員ポイントのご利用にあたって',
        got_it: '確認',
        tabs: {
            all: 'すべて',
            earn: '獲得',
            redeem: '取得'
        },
        upgradeApp:"APPを最新バージョンにアップグレードしてください",
    },
    member: {
        membership: 'メンバーシップ',
        hello_member: 'こんにちは、会員様',
        update: 'アップグレード',
        vip_member_benefits: 'VIP会員権',
        packages: 'データプラン/パッケージ',
        discounts: '割引価格',
        points: 'ポイント',
        membership_policy: 'VIP会員規約',
        faq: 'よくある質問',
        update_to_vip_membership: 'VIP会員にアップグレード',
        vip_member: 'VIP会員',
        valid_till: 'まで有効',
        renew: '更新',
        months: '月',
        payment: '支払確認',
        vip_membership: 'VIP会員',
        enjoy_vip_member_benefits: '{len}プレミアムVIP会員特典をお使い頂けます！',
        by_purchasing_you_agree_to: 'ご購入は同意したものと見なされます',
        coupon: '割引',
        available_coupon: '{num}個利用可',
        no_available_coupon: '利用可能なクーポンがありません',
        actual_price: 'お支払い金額',
        payment_success_text: 'ご購入いただいた後、パッケージは自動的に追加されます。',
        balance: '残高',
        online_payment: 'オンライン支払',
        faq_title: 'FAQs',
        policy_title: '会員プライバシー',
        introduce_title: '会員紹介'
    },
    order: {
        periodUnit: {
            day: '日',
            month: '月',
            year: '年'
        },
        periodUnits: {
            day: '日',
            month: '月',
            year: '年'
        },
        balance_payment_dialog: {
            title: '購入を確定',
            content: 'アカウント残高から支払う',
            noSelectPackageTitle: 'プランが選択されていません',
            noSelectPackageContent: 'まずコースをお選びください',
        },
        purcase_successful: '購入成功',
        vip_membership: 'VIP会員',
        total: '支払い金額',
        finish_btn: '戻る',
        get_order_status: '注文内容を確認しています。',
        order_status_tip: '支払い保留',
        order_status_note_user: 'お支払い内容を確認しています。10分以内に完了できない場合は、カスタマーサービスにお問い合わせください。',
        order_status_btn_text: '完了',
        ios_iap_pay_btn: '購入する'
    },
    faq: {
        page_title: 'FAQs',
        mydevice: 'マイデバイス',
        more: '他のデバイス',
        more_faq: 'その他の問題',
        all_device: 'すべてのデバイス',
        faq_detail: '詳細',
    },
    device: {
        page_title: 'ユーザーマニュアル',
    },
    vpn: {
        page_title: 'VPNに関するよくある質問',
        faq_detail: '詳細',
    },
    esim: {
        page_title: 'ESIMに関するよくある質問',
        faq_detail: '詳細',
    },
    deviceGuide: {
        title: 'デバイスを選択してください',
        skip: 'スキップ',
    },
    give_set: {
        give_set_page_title: 'データ送り設定',
        give_set_page_set_btn: '保存',
        title: 'VIPギフトデータパッケージ設定',
        desc: 'VIPをアップグレードすると、設定されたデバイスに定期的にギフトデータパッケージをサービスします。紐付けされていないデバイスでは受信できません。',
        select_device_placeholder: 'デバイスを選択してください',
        select_device_title: 'デバイスを選択する',
        no_device_title: 'デバイスを紐付けしていません。',
        no_device_desc: 'バインディングデバイスのタイプを選択してください',
        bind_type_by_scan: 'スキャン',
        bind_type_by_type: 'モデル',
        disable_device_desc: 'ギフトデータパッケージは紐付けされたデバイスで使用できません。対応するデバイスを紐付けしてください',
        bind_device: 'デバイスを紐づける',
        give_set_success: '設定成功',
        give_set_leave_desc: '現在の設定は保存されません。現在のページを離れてもよろしいですか？',
        give_guide_tip: 'データ送り設定を編集するには、ここをクリックしてください。',
        get_it: '確認',
        give_set_saved: '保存完了'
    },
    guide: {
        newUser: {
            title: '初心者ガイドライン',
            top_bar: {
                device: '端末のインタネットに接続したい',
                sim: 'SIMのインタネットに接続したい'
            },
            step: {
                title: '端末のインターネットにアクセスする方法は何ですか',
                bind_device: 'デバイスを紐づける',
                buy_package: 'データ購入',
                use: '電源を入れて使用します'
            },
            sub_bar: {
                device: 'デバイス',
                package: '容量',
                use: '使用'
            },
            content: {
                device: {
                    list: [
                        {
                            title: 'デバイスをバインドするには：',
                            content: [
                                {
                                    text: '1.ログイン時にバインドしてください。或は[デバイスページ]に移動し、またはデータプラン購入時にデバイスをバインドしてください。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                    type:'text'
                                },
                                {
                                    text: '2. スマートフォンでQRコードをスキャンするか、デバイスの設定でQRコードを見つけます。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                    type:'text'
                                },
                                {
                                    text: '3. QRコードがない場合は、デバイスモデルを選択して指示に従ってください。',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                    type:'text'
                                },
                                {
                                    text: '全てのステップを完了して、バインドが成功するようにしてください。',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                    type:'tips'
                                }
                               
                            ],
                        }
                    ]
                },
                package: {
                    list: [
                        {
                            title: 'ローカルデータプランを購入するには：',
                            content: [
                                {
                                    text: '1. アプリで[ストア] > [ローカルサービス]に移動してください。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '2. 理想のデータプランを選択してください。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '3. [購入]をクリックして支払いを完了してください。',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                            ]
                        },
                        {
                            title: 'グローバルデータプランを購入するには:',
                            content: [
                                {
                                    text: '1. [ホームページ]に移動します。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '2. [目的地とデータを検索する]をクリックしてください。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                },
                                {
                                    text: '3.目的地の国または地域を入力してください。',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                },
                                {
                                    text: '4.場所、期間、ネットワークタイプに基づいてデータプランを選択します。',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                },
                                {
                                    text: '5. [購入]をクリックして支払いを完了してください。',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                },
                                {
                                    text: 'プランを購入する前にデバイスをバインドしてください。',
                                    imgSrc: '',
                                    type:'tips',
                                    desc: '',
                                    parentClass: '',
                                    class: '',

                                }
                            ]
                        },
                    ]
                },
                use: {
                    list: [
                        {
                            title: 'インターネット接続するには：',
                            content: [
                                {
                                    text: 'インターネット接続するには：',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '1.ローカルサービス「ローカルデータプラン」の場合：デバイスをオンにするか、再起動して有効化してください。',
                                    imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-net-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '2.グローバルサービス「グローバルデータプラン」の場合：目的地でデバイスをオンにし、ネットワークに接続すると自動的に有効化され、インターネットにアクセスできます。',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                },
                                {
                                    text: '(初回のインターネット接続には約2～3分かかりますので、しばらくお待ちください。）',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                    type:'tips'
                                },
                            ]
                        }
                    ],
                },
                sim: {
                list: [
                    {
                        title: 'SIMカードを使ってインターネットに接続するにはどうすればいいですか？',
                        content: [
                            {
                                text: '1.取扱説明書に従って、利用可能なSIMカードを端末のスロットに挿入した後、端末を再起動すると正常に利用できます（画面付きの端末は、端末画面でSIMカードモードに切り替える必要があります）。',
                                imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-1@3x.png',
                                desc: '',
                                parentClass: '',
                                class: '',
                            },
                            {
                                text: '2、携帯電話で端末のWi-Fiに接続し、Appの端末詳細ページで、SIM機能をクリックして、SIMモードに切り替えることもできます。',
                                imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-2@3x.png',
                                desc: '',
                                parentClass: '',
                                class: '',
                            }
                        ]
                    }
                ]
                }
            }
        }
    }
}





// WEBPACK FOOTER //
// ./src/lang/ja-JP.js